// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1IOQzOAHjvIy11Bn4m2axk","Body":"wd5HyROch8PfeBeIY5Vta","Group":"_1DOiU0G_S-3Tk7d9xWgNYf","Title":"_6Umkj1n-EscUSiI7QAZ2-","Column":"_2LxLKEzsP8lirLtFazm9x1","CheckboxWrap":"_1kHjYiYaDLezsxjb_LvdVd","CustomCheckbox":"_3JxMBzqCkmI9Qqk7QJ9bMq","InputIcon":"_36KHiYlk5WBvQgduYietwN","ActiveIcon":"_1RnYnSVkSKIoUnr1NDnmq3","BlockIcon":"_1y8AQFsaVTQhFxoCemqoNm","InactiveIcon":"_1MFyLLgGLccUzyILBoHxSX","ClosedIcon":"_3gimwXxHE-y0ttwzyT2GcQ","Footer":"_1dsm9bMh6mibCD5UC-MxBN","Submit":"_2ztRQBS2sYukDzBqwZ-92O","buttonIcon":"D1VZhRfYW84FTcrCMksjp"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AccountsFilters/styles.module.css
// module id = 530
// module chunks = 0